import React, { useState, useRef, useEffect } from 'react';
import {
  Card, CardBody, CardTitle, Nav, NavItem, NavLink, TabContent, TabPane,
  Row, Col, Label, Input, Form, Button, Badge, InputGroup, Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import classnames from 'classnames';
import { Editor } from '@tinymce/tinymce-react';
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import api, { FILE_BASE_URL } from '../../utils/api';
import useDuplicateCheck from '../../helpers/useDuplicateCheck';
import DuplicateWarning, { DuplicateSaveConfirm } from '../../components/DuplicateWarning';

const CreateActivist = (props) => {
  const { mode = 'create', activistData = null } = props;
  const imageInputRef = useRef(null);
  const attachmentInputRef = useRef(null);
  const videoInputRef = useRef(null); // 🆕 مرجع رفع الفيديو
  
  // ✅ إضافات جديدة للصورة الشخصية وجدول الأطفال والتصريحات
  const profileImageRef = useRef(null);
  const [profileImage, setProfileImage] = useState(null);
  const [children, setChildren] = useState([]);
  const [newChild, setNewChild] = useState({ name: '', gender: '', birth_date: '' });
  const [statements, setStatements] = useState([]);
  const [newStatement, setNewStatement] = useState({ title: '', content: '' });
  const [editingStatement, setEditingStatement] = useState(null);
  const [showStatementModal, setShowStatementModal] = useState(false); // 🆕 حالة Modal التصريحات
  
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeTab, setActiveTab] = useState('1');
  const [newSocialAccount, setNewSocialAccount] = useState('');
  const [newYoutubeLink, setNewYoutubeLink] = useState('');
  const [institutionsList, setInstitutionsList] = useState([]);
  const [journalistsList, setJournalistsList] = useState([]);
  const [activistsList, setActivistsList] = useState([]); // 🔗 لربط ناشط بناشط آخر
  const [images, setImages] = useState([]);
  const [videoFiles, setVideoFiles] = useState([]); // 🆕 ملفات الفيديو
  const [videoUploading, setVideoUploading] = useState({}); // 🆕 حالة رفع كل فيديو {id: {progress: 0-100, status: 'uploading'|'done'|'error'}}

  // 🆕 Multi-select states for institutions and journalists
  const [selectedInstitutions, setSelectedInstitutions] = useState([]);
  const [selectedJournalists, setSelectedJournalists] = useState([]);
  const [selectedActivistPeers, setSelectedActivistPeers] = useState([]); // 🔗 ناشطون آخرون مرتبطون
  const [institutionSearchTerm, setInstitutionSearchTerm] = useState('');
  const [journalistSearchTerm, setJournalistSearchTerm] = useState('');
  const [activistPeerSearchTerm, setActivistPeerSearchTerm] = useState('');
  const [filteredInstitutions, setFilteredInstitutions] = useState([]);
  const [filteredJournalistsList, setFilteredJournalistsList] = useState([]);
  const [filteredActivistPeers, setFilteredActivistPeers] = useState([]);

  // فحص الأسماء المكررة
  const { duplicateWarning, checkingDuplicate, duplicateError, handleNameBlur, handleNameChange, dismissWarning, checkBeforeSave } = useDuplicateCheck('activist', activistData?.id);
  const [showDuplicateConfirm, setShowDuplicateConfirm] = useState(false);
  const [pendingSubmitEvent, setPendingSubmitEvent] = useState(null);
  const [newInstitutionName, setNewInstitutionName] = useState('');
  const [newJournalistName, setNewJournalistName] = useState('');
  const [newInstitutions, setNewInstitutions] = useState([]);
  const [newJournalists, setNewJournalists] = useState([]);

  //  formValues محدث بالحقول الجديدة
  const [formValues, setFormValues] = useState({
    full_name: '',
    profile_image: '',
    bio: '',
    gender: '',
    id_number: '',
    birth_date: '',
    marital_status: '',
    children_details: [],
    political_orientation: [],
    country: 'فلسطين', // 🆕 الدولة مع القيمة الافتراضية
    country_province: '',
    city_or_area: '',
    address_details: '',
    map_address: '',
    specialization: '',
    university_name: '',
    last_work_place: '',
    work_sector: [],
    linked_institution: '',
    linked_journalists: [],
    linked_activists: [],
    whatsapp1_code: '+970',
    whatsapp1_number: '',
    phone_fax: '',
    mobile1: '',
    oreedo_number: '',
    email: '',
    website: '',
    social_accounts: [],
    statements: [],
    videos: [],
    attachments: [],
    video_files: [], // 🆕 ملفات فيديو مرفوعة
  });

  // ✅ دوال الصورة الشخصية وجدول الأطفال
  const handleProfileImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImage(file);
    }
  };

  const handleAddChild = () => {
    if (newChild.name.trim()) {
      setChildren([...children, { ...newChild, id: Date.now() }]);
      setNewChild({ name: '', gender: '', birth_date: '' });
    }
  };

  const handleRemoveChild = (id) => {
    setChildren(children.filter(child => child.id !== id));
  };

  // 🆕 دوال التصريحات المحدثة مع Modal والمحرر الغني
  const handleOpenStatementModal = () => {
    setEditingStatement(null);
    setNewStatement({ title: '', content: '' });
    setShowStatementModal(true);
  };

  const handleEditStatement = (stmt) => {
    setEditingStatement(stmt);
    setNewStatement({ title: stmt.title, content: stmt.content });
    setShowStatementModal(true);
  };

  const handleSaveStatement = () => {
    if (!newStatement.title.trim() || !newStatement.content.trim()) return;
    
    if (editingStatement) {
      // تحديث تصريح موجود
      setStatements(prev => prev.map(stmt => 
        stmt.id === editingStatement.id 
          ? { ...stmt, title: newStatement.title.trim(), content: newStatement.content.trim() }
          : stmt
      ));
    } else {
      // إضافة تصريح جديد
      setStatements(prev => [
        ...prev,
        {
          id: Date.now(),
          title: newStatement.title.trim(),
          content: newStatement.content.trim(),
          date: new Date().toISOString().split('T')[0],
          order: prev.length + 1
        }
      ]);
    }
    
    setNewStatement({ title: '', content: '' });
    setEditingStatement(null);
    setShowStatementModal(false);
  };

  const handleDeleteStatement = (id) => {
    setStatements(prev => prev.filter(stmt => stmt.id !== id));
  };

  const handleCancelStatementModal = () => {
    setNewStatement({ title: '', content: '' });
    setEditingStatement(null);
    setShowStatementModal(false);
  };

  const handleCancelEdit = () => {
    setEditingStatement(null);
    setNewStatement({ title: '', content: '' });
  };

  // 🆕 Institution handling functions
  const handleAddNewInstitution = () => {
    console.log('🔍 تم استدعاء handleAddNewInstitution');
    console.log('🔍 اسم المؤسسة الجديدة:', newInstitutionName);
    
    if (newInstitutionName.trim()) {
      const tempId = `new_${Date.now()}`;
      console.log('🔍 المعرف المؤقت:', tempId);
      
      const newInstitution = { id: tempId, title: newInstitutionName.trim() };
      console.log('🔍 المؤسسة الجديدة:', newInstitution);
      
      setNewInstitutions(prev => {
        const updated = [...prev, newInstitution];
        console.log('🔍 قائمة المؤسسات الجديدة المحدثة:', updated);
        return updated;
      });
      
      setSelectedInstitutions(prev => {
        const updated = [...prev, { id: tempId, title: newInstitutionName.trim(), isNew: true }];
        console.log('🔍 قائمة المؤسسات المحددة المحدثة:', updated);
        return updated;
      });
      
      setNewInstitutionName('');
      console.log('✅ تم إضافة المؤسسة الجديدة بنجاح');
    } else {
      console.log('❌ اسم المؤسسة فارغ');
    }
  };

  const handleSelectInstitution = (institutionId) => {
    const institution = institutionsList.find(inst => inst.id == institutionId);
    if (institution && !selectedInstitutions.find(sel => sel.id == institutionId)) {
      setSelectedInstitutions(prev => [...prev, { ...institution, isNew: false }]);
    }
  };

  const handleRemoveInstitution = (institutionId) => {
    setSelectedInstitutions(prev => prev.filter(inst => inst.id !== institutionId));
    // إذا كانت مؤسسة جديدة، احذفها من قائمة الجديدة أيضاً
    setNewInstitutions(prev => prev.filter(inst => inst.id !== institutionId));
  };

  // 🆕 Journalist handling functions
  const handleAddNewJournalist = () => {
    if (newJournalistName.trim()) {
      const tempId = `new_${Date.now()}`;
      setNewJournalists(prev => [...prev, { id: tempId, full_name: newJournalistName.trim() }]);
      setSelectedJournalists(prev => [...prev, { id: tempId, full_name: newJournalistName.trim(), isNew: true }]);
      setNewJournalistName('');
    }
  };

  const handleSelectJournalist = (journalistId) => {
    const journalist = journalistsList.find(jour => jour.id == journalistId);
    if (journalist && !selectedJournalists.find(sel => sel.id == journalistId)) {
      setSelectedJournalists(prev => [...prev, { ...journalist, isNew: false }]);
    }
  };

  const handleRemoveJournalist = (journalistId) => {
    setSelectedJournalists(prev => prev.filter(jour => jour.id !== journalistId));
    // إذا كان صحفي جديد، احذفه من قائمة الجديدة أيضاً
    setNewJournalists(prev => prev.filter(jour => jour.id !== journalistId));
  };

  // 🔗 دوال التعامل مع ربط ناشط بناشط آخر (اختيار من الموجودين فقط)
  const handleSelectActivistPeer = (activistId) => {
    const peer = activistsList.find(act => act.id == activistId);
    if (peer && !selectedActivistPeers.find(sel => sel.id == activistId)) {
      setSelectedActivistPeers(prev => [...prev, { ...peer, isNew: false }]);
    }
  };

  const handleRemoveActivistPeer = (activistId) => {
    setSelectedActivistPeers(prev => prev.filter(act => act.id !== activistId));
  };

  //  useEffect للخريطة
  useEffect(() => {
    if (document.getElementById("map") && window.google) {
      const defaultPosition = { lat: 31.9522, lng: 35.2332 };
      const map = new window.google.maps.Map(document.getElementById("map"), {
        center: defaultPosition,
        zoom: 13,
      });
      const marker = new window.google.maps.Marker({
        position: defaultPosition,
        map,
        draggable: true,
      });
      marker.addListener("dragend", () => {
        const position = marker.getPosition();
        setFormValues(prev => ({
          ...prev,
          map_address: `${position.lat()}, ${position.lng()}`,
        }));
      });
    }
  }, []);

  //  useEffect للتحديث (edit mode)
  useEffect(() => {
    if (mode === 'edit' && activistData) {
      setFormValues({
        full_name: activistData.full_name ?? '',
        profile_image: activistData.profile_image ?? '',
        bio: activistData.bio ?? '',
        gender: activistData.gender ?? '',
        id_number: activistData.id_number ?? '',
        birth_date: activistData.birth_date ?? '',
        marital_status: activistData.marital_status ?? '',
        children_details: Array.isArray(activistData.children_details) ? activistData.children_details : [],
        political_orientation: Array.isArray(activistData.political_orientation) ? activistData.political_orientation : [],
        country: activistData.country ?? 'فلسطين', // 🆕 إضافة حقل الدولة
        country_province: activistData.country_province ?? '',
        city_or_area: activistData.city_or_area ?? '',
        address_details: activistData.address_details ?? '',
        map_address: activistData.map_address ?? '',
        specialization: activistData.specialization ?? '',
        university_name: activistData.university_name ?? '',
        last_work_place: activistData.last_work_place ?? '',
        work_sector: Array.isArray(activistData.work_sector) ? activistData.work_sector : activistData.work_sector ? JSON.parse(activistData.work_sector) : [],
        linked_institution: activistData.linked_institution ?? '',
        linked_journalists: Array.isArray(activistData.linked_journalists) ? activistData.linked_journalists : activistData.linked_journalists ? JSON.parse(activistData.linked_journalists) : [],
        linked_activists: Array.isArray(activistData.linked_activists) ? activistData.linked_activists : activistData.linked_activists ? JSON.parse(activistData.linked_activists) : [],
        whatsapp1_code: activistData.whatsapp1?.startsWith('+972') ? '+972' : '+970',
        whatsapp1_number: activistData.whatsapp1 ? activistData.whatsapp1.replace(/^\+970|\+972/, '') : '',
        phone_fax: activistData.phone_fax ?? '',
        mobile1: activistData.mobile1 ?? '',
        oreedo_number: activistData.oreedo_number ?? '',
        email: activistData.email ?? '',
        website: activistData.website ?? '',
        social_accounts: Array.isArray(activistData.social_accounts) ? activistData.social_accounts : activistData.social_accounts ? JSON.parse(activistData.social_accounts) : [],
        statements: [],
        videos: Array.isArray(activistData.videos) ? activistData.videos : activistData.videos ? JSON.parse(activistData.videos) : [],
        attachments: activistData.attachments ? JSON.parse(activistData.attachments) : [],
        video_files: activistData.video_files ? JSON.parse(activistData.video_files) : [], // 🆕
      });

      // تحميل بيانات الأطفال
      if (activistData.children_details) {
        try {
          const parsedChildren = typeof activistData.children_details === 'string' 
            ? JSON.parse(activistData.children_details) 
            : activistData.children_details;
          setChildren(parsedChildren);
        } catch (e) {
          console.error("فشل في قراءة بيانات الأطفال:", e);
          setChildren([]);
        }
      }

      // تحميل الصور
      if (activistData.images) {
        try {
          const parsedImages = JSON.parse(activistData.images);
          setImages(parsedImages);
        } catch (e) {
          console.error("فشل في قراءة صور الناشط:", e);
          setImages([]);
        }
      } else {
        setImages([]);
      }

      // 🆕 تحميل ملفات الفيديو
      if (activistData.video_files) {
        try {
          const parsedVideoFiles = JSON.parse(activistData.video_files);
          setVideoFiles(parsedVideoFiles);
        } catch (e) {
          console.error("فشل في قراءة ملفات الفيديو:", e);
          setVideoFiles([]);
        }
      } else {
        setVideoFiles([]);
      }

      //  تحميل بيانات التصريحات
      if (activistData.statements) {
        try {
          const parsedStatements = Array.isArray(activistData.statements) 
            ? activistData.statements 
            : JSON.parse(activistData.statements);
          setStatements(parsedStatements);
        } catch (e) {
          console.error("فشل في قراءة بيانات التصريحات:", e);
          setStatements([]);
        }
      } else {
        setStatements([]);
      }

      // 🆕 Load selected institutions and journalists for edit mode
      setTimeout(() => {
        console.log('🔄 محاولة تحميل البيانات المختارة...');
        console.log('🔄 بيانات الناشط:', activistData);
        console.log('🔄 قائمة المؤسسات:', institutionsList.length);
        console.log('🔄 قائمة الصحفيين:', journalistsList.length);
        
        // Load selected institutions
        if (activistData.linked_institution) {
          const institutionId = activistData.linked_institution;
          const institution = institutionsList.find(inst => inst.id == institutionId);
          if (institution) {
            console.log('🔄 تحميل المؤسسة المختارة:', institution);
            setSelectedInstitutions([{ ...institution, isNew: false }]);
          } else {
            console.log('❌ لم يتم العثور على المؤسسة بالمعرف:', institutionId);
          }
        }

        // Load selected journalists
        if (activistData.linked_journalists) {
          try {
            const journalistIds = Array.isArray(activistData.linked_journalists) 
              ? activistData.linked_journalists 
              : JSON.parse(activistData.linked_journalists);
            
            console.log('🔄 معرفات الصحفيين:', journalistIds);
            
            const selectedJournalistObjects = journalistIds
              .map(id => journalistsList.find(j => j.id == id))
              .filter(j => j !== undefined)
              .map(j => ({ ...j, isNew: false }));
            
            console.log('🔄 تحميل الصحفيين المختارين:', selectedJournalistObjects);
            setSelectedJournalists(selectedJournalistObjects);
          } catch (e) {
            console.error("فشل في تحميل الصحفيين المحددين:", e);
          }
        }
      }, 500); // تأخير قصير للتأكد من تحميل القوائم
    }
  }, [mode, activistData, institutionsList, journalistsList]);

  //  useEffect لجلب البيانات - تم تحديثه لاستخدام api
  useEffect(() => {
    // جلب قائمة المؤسسات
    api.get('/institutions')
      .then(res => {
        const institutions = Array.isArray(res.data) ? res.data : res.data.data || [];
        setInstitutionsList(institutions);
        setFilteredInstitutions(institutions);
      })
      .catch(error => {
        console.error('خطأ في جلب المؤسسات:', error);
        setInstitutionsList([]);
        setFilteredInstitutions([]);
      });

    // جلب قائمة الصحفيين
    api.get('/journalists')
      .then(res => {
        const journalists = Array.isArray(res.data) ? res.data : res.data.data || [];
        setJournalistsList(journalists);
        setFilteredJournalistsList(journalists);
      })
      .catch(error => {
        console.error('خطأ في جلب الصحفيين:', error);
        setJournalistsList([]);
        setFilteredJournalistsList([]);
      });

    // 🔗 جلب قائمة كل الناشطين لربط ناشط بناشط آخر
    api.get('/activists')
      .then(res => {
        const activists = Array.isArray(res.data) ? res.data : res.data.data || [];
        setActivistsList(activists);
        setFilteredActivistPeers(activists);
      })
      .catch(error => {
        console.error('خطأ في جلب الناشطين:', error);
        setActivistsList([]);
        setFilteredActivistPeers([]);
      });
  }, []);

  // 🆕 Filter institutions based on search
  useEffect(() => {
    if (!institutionSearchTerm.trim()) {
      setFilteredInstitutions(institutionsList);
    } else {
      const filtered = institutionsList.filter(inst => 
        inst.title?.toLowerCase().includes(institutionSearchTerm.toLowerCase()) ||
        inst.description?.toLowerCase().includes(institutionSearchTerm.toLowerCase())
      );
      setFilteredInstitutions(filtered);
    }
  }, [institutionSearchTerm, institutionsList]);

  // 🆕 Filter journalists based on search
  useEffect(() => {
    if (!journalistSearchTerm.trim()) {
      setFilteredJournalistsList(journalistsList);
    } else {
      const filtered = journalistsList.filter(journalist =>
        journalist.full_name?.toLowerCase().includes(journalistSearchTerm.toLowerCase()) ||
        journalist.specialization?.toLowerCase().includes(journalistSearchTerm.toLowerCase())
      );
      setFilteredJournalistsList(filtered);
    }
  }, [journalistSearchTerm, journalistsList]);

  // 🔗 Filter activist peers based on search
  useEffect(() => {
    if (!activistPeerSearchTerm.trim()) {
      setFilteredActivistPeers(activistsList);
    } else {
      const filtered = activistsList.filter(act =>
        act.full_name?.toLowerCase().includes(activistPeerSearchTerm.toLowerCase())
      );
      setFilteredActivistPeers(filtered);
    }
  }, [activistPeerSearchTerm, activistsList]);

  // 🔗 تحميل الناشطين المرتبطين مسبقاً في وضع التعديل
  useEffect(() => {
    if (mode === 'edit' && activistData && activistsList.length > 0) {
      setTimeout(() => {
        if (activistData.linked_activists) {
          try {
            const linkedIds = Array.isArray(activistData.linked_activists)
              ? activistData.linked_activists
              : JSON.parse(activistData.linked_activists || '[]');

            const linkedPeers = linkedIds
              .map(id => activistsList.find(act => act.id == id))
              .filter(Boolean)
              .filter(act => act.id != activistData.id)
              .map(act => ({ ...act, isNew: false }));

            setSelectedActivistPeers(linkedPeers);
          } catch (e) {
            console.error("فشل في تحميل الناشطين المرتبطين:", e);
          }
        }
      }, 500);
    }
  }, [mode, activistData, activistsList]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // إذا تم تغيير الدولة، قم بإعادة تعيين المحافظة
    if (name === 'country' && value !== 'فلسطين') {
      setFormValues(prev => ({
        ...prev,
        [name]: value,
        country_province: '' // إعادة تعيين المحافظة
      }));
    } else {
      setFormValues(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleAddToArray = (key, valueSetter, value) => {
    if (value.trim()) {
      setFormValues(prev => ({
        ...prev,
        [key]: [...prev[key] || [], value.trim()]
      }));
      valueSetter('');
    }
  };

  const handleRemoveFromArray = (key, index) => {
    setFormValues(prev => ({
      ...prev,
      [key]: prev[key].filter((_, i) => i !== index)
    }));
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setImages([...images, ...files]);
  };

  // 🆕 رفع ملفات الفيديو مع تتبع التقدم - يبدأ الرفع فوراً
  const handleVideoUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    const valid = files.filter(f => f.size <= 1024 * 1024 * 1024); // 1GB max
    
    for (const file of valid) {
      const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      
      // إضافة الملف مع معرف مؤقت
      setVideoFiles(prev => [...prev, { tempId, file, name: file.name, size: file.size, status: 'uploading' }]);
      setVideoUploading(prev => ({ ...prev, [tempId]: { progress: 0, status: 'uploading' } }));
      
      // بدء الرفع
      const fd = new FormData();
      fd.append('video', file);
      
      try {
        const res = await api.post('/upload-video', fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setVideoUploading(prev => ({ ...prev, [tempId]: { progress: percent, status: 'uploading' } }));
          }
        });
        
        // نجح الرفع - استبدال الملف المؤقت بالاسم النهائي
        const uploadedName = res.data.name;
        setVideoFiles(prev => prev.map(v => 
          v.tempId === tempId ? uploadedName : v
        ));
        setVideoUploading(prev => ({ ...prev, [tempId]: { progress: 100, status: 'done' } }));
      } catch (err) {
        console.error('فشل رفع الفيديو:', err);
        setVideoUploading(prev => ({ ...prev, [tempId]: { progress: 0, status: 'error', message: err.response?.data?.message || 'فشل رفع الفيديو' } }));
        // إزالة الملف الفاشل من القائمة
        setVideoFiles(prev => prev.filter(v => v.tempId !== tempId));
      }
    }
    
    // تنظيف حقل الإدخال
    if (videoInputRef.current) videoInputRef.current.value = null;
  };

  //  دالة رفع الملفات - تم تحديثها لاستخدام api
  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    try {
      const response = await api.post('/upload-file', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data.name;
    } catch (error) {
      console.error('فشل رفع الملف:', error);
      return null;
    }
  };

  // 🆕 تحقق من اكتمال رفع جميع الفيديوهات
  const areAllVideosUploaded = () => {
    return videoFiles.every(v => typeof v === 'string');
  };

  // 🆕 الحصول على أسماء الفيديوهات المرفوعة فقط
  const getUploadedVideoNames = () => {
    return videoFiles.filter(v => typeof v === 'string');
  };

  // Added helper (fix missing renderFileMeta)
  const renderFileMeta = (fileName = '') => {
    const ext = (fileName.split('.').pop() || '').toLowerCase();
    switch (ext) {
      case 'pdf':   return ['fas fa-file-pdf', 'text-danger', 'ملف PDF'];
      case 'doc':
      case 'docx':  return ['fas fa-file-word', 'text-primary', 'ملف Word'];
      case 'xls':
      case 'xlsx':  return ['fas fa-file-excel', 'text-success', 'ملف Excel'];
      case 'ppt':
      case 'pptx':  return ['fas fa-file-powerpoint', 'text-warning', 'ملف PowerPoint'];
      case 'txt':   return ['fas fa-file-alt', 'text-muted', 'ملف نصي'];
      default:      return ['fas fa-file', 'text-secondary', 'ملف'];
    }
  };

  //  دالة الإرسال - تم تحديثها لاستخدام api
  const handleSubmit = async (e) => {
    e.preventDefault();
    // فحص التكرار قبل الحفظ
    const matches = await checkBeforeSave(formValues.full_name);
    if (matches && matches.length > 0) {
      setShowDuplicateConfirm(true);
      return;
    }
    doActualSubmit();
  };

  const doActualSubmit = async () => {
    setIsSubmitting(true);
    
    try {
      console.log('🔍 بدء عملية الحفظ...');
      console.log('📋 المؤسسات الجديدة:', newInstitutions);
      console.log('📋 المؤسسات المحددة:', selectedInstitutions);
      console.log('📋 الصحفيين الجدد:', newJournalists);
      console.log('📋 الصحفيين المحددين:', selectedJournalists);

      // 🆕 إنشاء المؤسسات الجديدة أولاً
      const createdInstitutions = [];
      if (newInstitutions.length > 0) {
        console.log('🏢 بدء إنشاء المؤسسات الجديدة...');
        console.log('🏢 عدد المؤسسات الجديدة:', newInstitutions.length);
        console.log('🏢 قائمة المؤسسات الجديدة:', newInstitutions);
        
        for (const newInst of newInstitutions) {
          try {
            console.log('🏢 إنشاء مؤسسة:', newInst.title);
            const response = await api.post('/institutions', {
              title: newInst.title,
              description: `مؤسسة تم إنشاؤها تلقائياً من خلال إضافة ناشط`,
              license_status: 'مرخص',
              orientation: 'محايد',
              country: 'فلسطين',
              country_province: '',
              city_or_area: '',
              address_details: '',
            });
            console.log('✅ تم إنشاء المؤسسة بنجاح:', response.data);
            const institutionId = response.data?.id || response.data?.data?.id;
            if (institutionId) {
              createdInstitutions.push({ oldId: newInst.id, newId: institutionId });
            } else {
              console.error('❌ لم يتم العثور على معرف المؤسسة في الاستجابة:', response.data);
            }
          } catch (err) {
            console.error('❌ فشل في إنشاء المؤسسة:', newInst.title, err);
            console.error('❌ تفاصيل الخطأ:', err.response?.data || err);
          }
        }
      } else {
        console.log('🏢 لا توجد مؤسسات جديدة لإنشائها');
      }

      // 🆕 إنشاء الصحفيين الجدد ثانياً
      const createdJournalists = [];
      if (newJournalists.length > 0) {
        console.log('👥 بدء إنشاء الصحفيين الجدد...');
        
        for (const newJour of newJournalists) {
          try {
            console.log('👤 إنشاء صحفي:', newJour.full_name);
            const response = await api.post('/journalists', {
              full_name: newJour.full_name,
              bio: `صحفي تم إنشاؤه تلقائياً من خلال إضافة ناشط`,
              gender: 'ذكر',
              country: 'فلسطين',
              country_province: '',
              city_or_area: '',
              address_details: '',
              profession: 'صحفي',
              work_details: '',
              specialization: '',
              university_name: '',
              last_work_place: '',
              work_sector: JSON.stringify([]),
              political_orientation: [],
              // ❌ لا نربط الصحفي بمؤسسات الناشط - يجب أن يبقى مستقل
              institution: '',
              linked_institution: JSON.stringify([]),
              linked_activists: '[]', // سيتم تحديثه لاحقاً بمعرف الناشط الجديد
            });
            console.log('✅ تم إنشاء الصحفي بنجاح:', response.data);
            const journalistId = response.data?.id || response.data?.data?.id;
            if (journalistId) {
              createdJournalists.push({ oldId: newJour.id, newId: journalistId });
            } else {
              console.error('❌ لم يتم العثور على معرف الصحفي في الاستجابة:', response.data);
            }
          } catch (err) {
            console.error('❌ فشل في إنشاء الصحفي:', newJour.full_name, err);
          }
        }
      }

      // 🔄 تحديث معرفات المؤسسات والصحفيين المحددين
      const finalInstitutionIds = selectedInstitutions.map(inst => {
        if (inst.isNew) {
          const created = createdInstitutions.find(c => c.oldId === inst.id);
          return created && created.newId ? String(created.newId) : null;
        }
        return inst.id ? String(inst.id) : null;
      }).filter(id => id);

      const finalJournalistIds = selectedJournalists.map(jour => {
        if (jour.isNew) {
          const created = createdJournalists.find(c => c.oldId === jour.id);
          return created && created.newId ? String(created.newId) : null;
        }
        return jour.id ? String(jour.id) : null;
      }).filter(id => id);

      // 🔗 الناشطون الآخرون المرتبطون (اختيار من الموجودين فقط، لا يوجد "جديد")
      const finalActivistPeerIds = selectedActivistPeers
        .map(act => act.id ? String(act.id) : null)
        .filter(Boolean);

      console.log('🔗 معرفات المؤسسات النهائية:', finalInstitutionIds);
      console.log('🔗 معرفات الصحفيين النهائية:', finalJournalistIds);
      console.log('🔗 معرفات الناشطين الآخرين النهائية:', finalActivistPeerIds);
      console.log('🔍 createdInstitutions:', createdInstitutions);
      console.log('🔍 createdJournalists:', createdJournalists);

      // 1. رفع الصورة الشخصية
      let uploadedProfileImage = formValues.profile_image || '';
      if (profileImage && typeof profileImage !== 'string') {
        uploadedProfileImage = await uploadFile(profileImage);
      }

      // 2. رفع الصور العادية
      const uploadedImages = await Promise.all(
        images.map(file => typeof file === 'string' ? file : uploadFile(file))
      );

      // 3. رفع المرفقات
      const uploadedAttachments = await Promise.all(
        (formValues.attachments || []).map(file =>
          typeof file === 'string' ? file : uploadFile(file)
        )
      );

      // 🆕 4. الفيديوهات (تم رفعها مسبقاً - نأخذ الأسماء المرفوعة فقط)
      if (!areAllVideosUploaded()) {
        alert('يرجى انتظار اكتمال رفع جميع ملفات الفيديو');
        setIsSubmitting(false);
        return;
      }
      const finalVideoFiles = getUploadedVideoNames();

      // 5. تنظيف النتائج
      const finalImages = uploadedImages.filter(Boolean);
      const finalAttachments = uploadedAttachments.filter(Boolean);

      // 6. إعداد البيانات للإرسال
      const dataToSend = {
        full_name: formValues.full_name || '',
        profile_image: uploadedProfileImage || '',
        bio: formValues.bio || '',
        gender: formValues.gender || '',
        id_number: formValues.id_number || '',
        birth_date: formValues.birth_date || '',
        marital_status: formValues.marital_status || '',
        children_details: JSON.stringify(children),
        political_orientation: formValues.political_orientation || [],
        country: formValues.country || 'فلسطين',
        country_province: formValues.country_province || '',
        city_or_area: formValues.city_or_area || '',
        address_details: formValues.address_details || '',
        map_address: formValues.map_address || '',
        specialization: formValues.specialization || '',
        university_name: formValues.university_name || '',
        last_work_place: formValues.last_work_place || '',
        work_sector: JSON.stringify(formValues.work_sector || []),
        // 🔗 كل المؤسسات في حقل واحد (ما في مؤسسة "أساسية" منفصلة)
        linked_institution: JSON.stringify(finalInstitutionIds),
        linked_journalists: JSON.stringify(finalJournalistIds),
        linked_activists: JSON.stringify(finalActivistPeerIds),
        whatsapp1: formValues.whatsapp1_number ? `${formValues.whatsapp1_code}${formValues.whatsapp1_number}` : '',
        phone_fax: formValues.phone_fax || '',
        mobile1: formValues.mobile1 || '',
        oreedo_number: formValues.oreedo_number || '',
        email: formValues.email || '',
        website: formValues.website || '',
        social_accounts: JSON.stringify(formValues.social_accounts || []),
        statements: JSON.stringify(statements),
        videos: JSON.stringify(formValues.videos || []),
        images: JSON.stringify(finalImages),
        attachments: JSON.stringify(finalAttachments),
        video_files: JSON.stringify(finalVideoFiles), // 🆕 ملفات فيديو
      };

      console.log("البيانات النهائية للإرسال:", dataToSend);

      // 6. الإرسال - تم تحديثه لاستخدام api
      let activistResponse;
      if (mode === 'edit') {
        activistResponse = await api.put(`/activists/${activistData.id}`, dataToSend, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        });
      } else {
        activistResponse = await api.post("/activists", dataToSend, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        });
      }

      // ✅ التحقق من طلب الموافقة (data_entry)
      if (activistResponse.data?.pending) {
        setFormErrors({});
        alert('تم إرسال طلبك للمراجعة من قبل المسؤول. سيتم إشعارك عند اتخاذ القرار.');
        window.location.href = '/dashboard/my-requests';
        return;
      }

      // 🔗 7. تحديث الصحفيين الجدد ليكونوا مرتبطين بالناشط المنشأ حديثاً
      if (mode === 'create' && createdJournalists.length > 0 && activistResponse.data) {
        const newActivistId = activistResponse.data?.id || activistResponse.data?.data?.id;
        if (newActivistId) {
          console.log('🔄 تحديث الصحفيين الجدد للربط مع الناشط:', newActivistId);
          
          for (const createdJour of createdJournalists) {
            try {
              // جلب بيانات الصحفي الحالية
              const journalistResponse = await api.get(`/journalists/${createdJour.newId}`);
              const currentJournalist = journalistResponse.data?.data || journalistResponse.data;
              
              // تحديث قائمة الناشطين المرتبطين
              const currentLinkedActivists = currentJournalist.linked_activists 
                ? JSON.parse(currentJournalist.linked_activists) 
                : [];
              
              if (!currentLinkedActivists.includes(String(newActivistId))) {
                currentLinkedActivists.push(String(newActivistId));
                
                // تحديث الصحفي
                await api.put(`/journalists/${createdJour.newId}`, {
                  ...currentJournalist,
                  linked_activists: JSON.stringify(currentLinkedActivists)
                });
                
                console.log(`✅ تم ربط الصحفي ${createdJour.newId} بالناشط ${newActivistId}`);
              }
            } catch (error) {
              console.error(`❌ فشل في ربط الصحفي ${createdJour.newId}:`, error);
            }
          }
        }

        // 🔄 ربط الصحفيين الموجودين (ليس الجدد) بالناشط الجديد 
        const existingJournalistIds = selectedJournalists
          .filter(jour => !jour.isNew) // فقط الصحفيين الموجودين
          .map(jour => String(jour.id));
        
        if (existingJournalistIds.length > 0 && newActivistId) {
          console.log('🔄 تحديث الصحفيين الموجودين للربط مع الناشط:', newActivistId);
          
          for (const journalistId of existingJournalistIds) {
            try {
              // جلب بيانات الصحفي الحالية
              const journalistResponse = await api.get(`/journalists/${journalistId}`);
              const currentJournalist = journalistResponse.data?.data || journalistResponse.data;
              
              // تحديث قائمة الناشطين المرتبطين
              const currentLinkedActivists = currentJournalist.linked_activists 
                ? JSON.parse(currentJournalist.linked_activists) 
                : [];
              
              if (!currentLinkedActivists.includes(String(newActivistId))) {
                currentLinkedActivists.push(String(newActivistId));
                
                // تحديث الصحفي
                await api.put(`/journalists/${journalistId}`, {
                  ...currentJournalist,
                  linked_activists: JSON.stringify(currentLinkedActivists)
                });
                
                console.log(`✅ تم ربط الصحفي الموجود ${journalistId} بالناشط ${newActivistId}`);
              }
            } catch (error) {
              console.error(`❌ فشل في ربط الصحفي الموجود ${journalistId}:`, error);
            }
          }
        }
      }

      // 🔗 مزامنة ثنائية الاتجاه لربط ناشط بناشط آخر (تعمل بحالتي الإنشاء والتعديل معاً)
      const currentActivistId = mode === 'edit'
        ? activistData.id
        : (activistResponse.data?.id || activistResponse.data?.data?.id);

      if (currentActivistId && finalActivistPeerIds.length > 0) {
        for (const peerId of finalActivistPeerIds) {
          try {
            const peerResponse = await api.get(`/activists/${peerId}`);
            const peerData = peerResponse.data?.data || peerResponse.data;

            const peerLinkedActivists = peerData.linked_activists
              ? JSON.parse(peerData.linked_activists)
              : [];

            if (!peerLinkedActivists.includes(String(currentActivistId))) {
              peerLinkedActivists.push(String(currentActivistId));

              // ملاحظة: نرسل full_name (حقل إلزامي) + الحقل المطلوب تحديثه فقط،
              // بدون بقية الحقول (بعضها مصفوفات مُحوَّلة مسبقاً ولا يجب إرسالها مجدداً)
              await api.put(`/activists/${peerId}`, {
                full_name: peerData.full_name,
                linked_activists: JSON.stringify(peerLinkedActivists)
              });

              console.log(`✅ تم ربط الناشط ${peerId} بالناشط ${currentActivistId}`);
            }
          } catch (error) {
            console.error(`❌ فشل في ربط الناشط ${peerId}:`, error);
          }
        }
      }

      setFormErrors({});
      alert(mode === 'edit' ? "تم تحديث الناشط بنجاح" : "تم إضافة الناشط بنجاح");
      window.location.href = "/dashboard/activists";
      
    } catch (error) {
      console.log("=== تفاصيل الخطأ ===");
      console.log("Status:", error.response?.status);
      console.log("Data:", error.response?.data);
      console.log("Full Error:", error);
      
      if (error.response?.status === 422) {
        console.log("Validation errors:", error.response.data.errors);
        setFormErrors(error.response.data.errors || {});
        alert("يرجى تصحيح الحقول المشار إليها");
      } else {
        console.error("فشل في الحفظ", error);
        alert("فشل في حفظ البيانات: " + (error.response?.data?.message || error.message));
      }
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <React.Fragment>
    <Card>
      <CardBody>
        <CardTitle className="h4 mb-4">{mode === 'edit' ? 'تحديث ناشط' : 'إضافة ناشط جديد'}</CardTitle>
        <Nav tabs className="nav-tabs-custom">
          <NavItem><NavLink className={classnames({ active: activeTab === '1' })} onClick={() => toggleTab('1')}>معلومات شخصية أساسية</NavLink></NavItem>
          <NavItem><NavLink className={classnames({ active: activeTab === '2' })} onClick={() => toggleTab('2')}>العنوان والموقع</NavLink></NavItem>
          <NavItem><NavLink className={classnames({ active: activeTab === '3' })} onClick={() => toggleTab('3')}>معلومات الاختصاص والعمل</NavLink></NavItem>
          <NavItem><NavLink className={classnames({ active: activeTab === '4' })} onClick={() => toggleTab('4')}>معلومات الاتصال والتواصل</NavLink></NavItem>
          <NavItem><NavLink className={classnames({ active: activeTab === '5' })} onClick={() => toggleTab('5')}>مرفقات</NavLink></NavItem>
        </Nav>

        <Form className="mt-4" onSubmit={handleSubmit}>
          <TabContent activeTab={activeTab}>
            {/* ✅ TabPane الأول محدث بالكامل */}
            <TabPane tabId="1">
  {/* ✅ المعلومات الأساسية في صف واحد */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-primary fw-bold mb-0">
        <i className="fas fa-user me-2"></i>
        المعلومات الأساسية
      </h5>
    </div>
    <Row className="g-4"> 
      {/* الاسم الكامل */}
      <Col md={3}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            الاسم الكامل <span className="text-danger">*</span>
          </Label>
          <Input
            name="full_name"
            value={formValues.full_name}
            onChange={(e) => { handleChange(e); handleNameChange(e.target.value); }}
            onBlur={handleNameBlur}
            className={`form-control-lg border-2 ${formErrors.full_name ? 'is-invalid border-danger' : 'border-primary'}`}
            placeholder="أدخل الاسم الكامل"
            required
          />
          {formErrors.full_name && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.full_name[0]}</div>
          )}
          <DuplicateWarning matches={duplicateWarning} checking={checkingDuplicate} error={duplicateError} onDismiss={dismissWarning} />
        </div>
      </Col>

      {/* الجنس */}
      <Col md={2}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">الجنس</Label>
          <div className="d-flex gap-3 mt-2">
            {['ذكر', 'أنثى'].map(gender => (
              <div key={gender} className="form-check">
                <input
                  className="form-check-input fs-5"
                  type="radio"
                  name="gender"
                  id={`gender_${gender}`}
                  value={gender}
                  checked={formValues.gender === gender}
                  onChange={handleChange}
                />
                <label className="form-check-label fw-semibold fs-6 text-dark ms-2" htmlFor={`gender_${gender}`}>
                  {gender}
                </label>
              </div>
            ))}
          </div>
        </div>
      </Col>

      {/* رقم الهوية */}
      <Col md={2}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">رقم الهوية</Label>
          <Input
            name="id_number"
            value={formValues.id_number}
            onChange={handleChange}
            className={`form-control-lg border-2 ${formErrors.id_number ? 'is-invalid border-danger' : 'border-primary'}`}
            placeholder="123456789"
          />
          {formErrors.id_number && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.id_number[0]}</div>
          )}
        </div>
      </Col>

      {/* تاريخ الميلاد */}
      <Col md={2}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">تاريخ الميلاد</Label>
          <Input
            type="date"
            name="birth_date"
            value={formValues.birth_date}
            onChange={handleChange}
            className={`form-control-lg border-2 ${formErrors.birth_date ? 'is-invalid border-danger' : 'border-primary'}`}
          />
          {formErrors.birth_date && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.birth_date[0]}</div>
          )}
        </div>
      </Col>

      {/* الحالة الاجتماعية */}
      <Col md={3}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">الحالة الاجتماعية</Label>
          <div className="d-flex gap-2 flex-wrap">
            {['متزوج', 'أعزب', 'مطلق', 'غير محدد'].map(status => (
              <div key={status} className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  name="marital_status"
                  id={`marital_status_${status}`}
                  value={status}
                  checked={formValues.marital_status === status}
                  onChange={handleChange}
                />
                <label className="form-check-label fw-semibold text-dark ms-2" htmlFor={`marital_status_${status}`}>
                  {status}
                </label>
              </div>
            ))}
          </div>
        </div>
      </Col>
    </Row>
  </div>

  {/* ✅ تفاصيل السيرة الذاتية */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-success fw-bold mb-0">
        <i className="fas fa-file-alt me-2"></i>
        السيرة الذاتية
      </h5>
    </div>
    <div className="p-4 border rounded-3 shadow-sm bg-white">
      <div className="editor-container" style={{ minHeight: '350px', width: '100%' }}>
        <Editor
          apiKey="s63csl3mxs9qcpfxz7ti9a4mx3zjto2mof448ll6atc7kxvi"
          value={formValues.bio}
          init={{
            height: 350,
            width: '100%',
            menubar: 'file edit view insert format tools table help',
            directionality: 'rtl',
            plugins: [
              'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
              'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
              'insertdatetime', 'media', 'table', 'help', 'wordcount'
            ],
            toolbar: 'undo redo | blocks fontfamily fontsize | forecolor backcolor | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | removeformat | help',
            font_family_formats: 'Arial=arial,helvetica,sans-serif; Times New Roman=times new roman,times,serif; Courier New=courier new,courier,monospace; Tahoma=tahoma,arial,helvetica,sans-serif; Verdana=verdana,arial,helvetica,sans-serif; Georgia=georgia,serif',
            font_size_formats: '8pt 10pt 12pt 14pt 16pt 18pt 20pt 24pt 26pt 36pt',
            toolbar_mode: 'sliding',
            branding: false,
            resize: true,
            statusbar: true,
            content_style: 'body { font-family: Tahoma, Arial, sans-serif; font-size: 16px; direction: rtl; }'
          }}
          onEditorChange={(content) => setFormValues({ ...formValues, bio: content })}
        />
      </div>
    </div>
  </div>

  {/* ✅ جدول الأبناء */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-info fw-bold mb-0">
        <i className="fas fa-baby me-2"></i>
        معلومات العائلة
      </h5>
    </div>
    <div className="p-4 border rounded-3 shadow-sm bg-white">
      
      {/* إضافة ابن جديد */}
      <div className="p-4 border-2 border-dashed border-info rounded-3 mb-4 bg-light">
        <h6 className="text-info fw-bold mb-3">
          <i className="fas fa-plus me-2"></i>
          إضافة ابن/ابنة جديد
        </h6>
        <Row className="g-3 align-items-end">
          <Col md={4}>
            <Label className="form-label fw-semibold mb-2 text-dark">اسم الابن/البنت</Label>
            <Input
              placeholder="أدخل الاسم الكامل"
              value={newChild.name}
              onChange={(e) => setNewChild({...newChild, name: e.target.value})}
              className="form-control-lg border-2 border-info"
            />
          </Col>
          <Col md={3}>
            <Label className="form-label fw-semibold mb-2 text-dark">الجنس</Label>
            <Input
              type="select"
              value={newChild.gender}
              onChange={(e) => setNewChild({...newChild, gender: e.target.value})}
              className="form-control-lg border-2 border-info"
            >
              <option value="">-- اختر الجنس --</option>
              <option value="ذكر">ذكر</option>
              <option value="أنثى">أنثى</option>
            </Input>
          </Col>
          <Col md={3}>
            <Label className="form-label fw-semibold mb-2 text-dark">تاريخ الميلاد</Label>
            <Input
              type="date"
              value={newChild.birth_date}
              onChange={(e) => setNewChild({...newChild, birth_date: e.target.value})}
              className="form-control-lg border-2 border-info"
            />
          </Col>
          <Col md={2}>
            <Button 
              color="info" 
              onClick={handleAddChild} 
              disabled={!newChild.name.trim()}
              className="w-100 fw-bold"
              size="lg"
            >
              <i className="fas fa-plus me-1"></i>
              إضافة
            </Button>
          </Col>
        </Row>
      </div>

      {/* جدول الأبناء */}
      {children.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-hover table-striped align-middle border-2">
            <thead className="table-info">
              <tr>
                <th className="fw-bold fs-6 py-3">#</th>
                <th className="fw-bold fs-6 py-3">الاسم الكامل</th>
                <th className="fw-bold fs-6 py-3">الجنس</th>
                <th className="fw-bold fs-6 py-3">تاريخ الميلاد</th>
                <th className="fw-bold fs-6 py-3 text-center">العمليات</th>
              </tr>
            </thead>
            <tbody>
              {children.map((child, index) => (
                <tr key={child.id || index} className="align-middle">
                  <td className="fw-medium text-muted py-3">{index + 1}</td>
                  <td className="fw-semibold text-dark py-3">{child.name}</td>
                  <td className="py-3">
                    <span className={`badge ${child.gender === 'ذكر' ? 'bg-primary' : 'bg-danger'} rounded-pill`}>
                      {child.gender}
                    </span>
                  </td>
                  <td className="text-muted py-3">{child.birth_date}</td>
                  <td className="text-center py-3">
                    <Button
                      color="outline-danger"
                      size="sm"
                      onClick={() => handleRemoveChild(child.id)}
                      className="fw-semibold px-3"
                    >
                      <i className="fas fa-trash me-1"></i>
                      حذف
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center py-5 text-muted">
          <i className="fas fa-baby fa-3x mb-3 opacity-50"></i>
          <p className="fs-5">لا توجد بيانات أبناء مضافة</p>
        </div>
      )}
    </div>
  </div>

  {/* ✅ الميول السياسية */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-warning fw-bold mb-0">
        <i className="fas fa-vote-yea me-2"></i>
        التوجهات السياسية
      </h5>
    </div>
    <div className="p-4 border rounded-3 shadow-sm bg-white">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <p className="text-muted mb-0">اختر الميول السياسية المناسبة (يمكن اختيار أكثر من خيار)</p>
        {formValues.political_orientation?.length > 0 && (
          <Button
            color="outline-danger"
            size="sm"
            onClick={() => setFormValues(prev => ({ ...prev, political_orientation: [] }))}
            className="fw-medium"
          >
            <i className="fas fa-times me-1"></i>
            إزالة كل التحديد
          </Button>
        )}
      </div>
      
      <div className="d-flex flex-wrap gap-3">
        {[
          "جبهة تحرير", "جبهة ديمقراطية", "جبهة شعبية", "جبهة عربية",
          "جبهة نضال", "جهاد اسلامي", "حركة حماس", "حركة فتح",
          "حزب شعب", "حزب فدا", "غير محدد", "مبادرة وطنية",
          "مستقل", "معارض", "يسار"
        ].map(item => {
          const isSelected = formValues.political_orientation?.includes(item);
          return (
            <button
              key={item}
              type="button"
              onClick={() => {
                const exists = formValues.political_orientation?.includes(item);
                setFormValues(prev => ({
                  ...prev,
                  political_orientation: exists
                    ? prev.political_orientation.filter(v => v !== item)
                    : [...(prev.political_orientation || []), item]
                }));
              }}
              className={`btn ${isSelected 
                ? 'btn-warning text-dark fw-bold' 
                : 'btn-outline-dark text-dark bg-light border-2'
              } fw-medium px-3 py-2 rounded-pill`}
              style={{ 
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                transform: isSelected ? 'scale(1.05)' : 'scale(1)',
                fontSize: '0.95rem',
                minHeight: '40px'
              }}
            >
              {isSelected && <i className="fas fa-check me-1"></i>}
              {item}
            </button>
          );
        })}
      </div>
      
      {formValues.political_orientation?.length > 0 && (
        <div className="mt-4 p-3 bg-light rounded">
          <div className="d-flex justify-content-between align-items-center">
            <small className="text-info fw-bold">
              <i className="fas fa-info-circle me-1"></i>
              تم اختيار {formValues.political_orientation.length} عنصر: 
              <span className="text-dark ms-1">
                {formValues.political_orientation.join(' - ')}
              </span>
            </small>
          </div>
        </div>
      )}
    </div>
  </div>

  {/* ✅ الصورة الشخصية */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-secondary fw-bold mb-0">
        <i className="fas fa-camera me-2"></i>
        الصورة الشخصية
      </h5>
    </div>
    <div className="p-4 border rounded-3 shadow-sm bg-white">
      <Row className="g-4 align-items-center">
        <Col md={6}>
          <div className="border-2 border-dashed border-secondary rounded-3 p-4 text-center">
            <Input
              type="file"
              accept="image/*"
              onChange={handleProfileImageUpload}
              className={`form-control-lg border-0 ${formErrors.profile_image ? 'is-invalid' : ''}`}
              innerRef={profileImageRef}
            />
            <div className="mt-2 text-muted">
              <i className="fas fa-cloud-upload-alt fa-2x mb-2"></i>
              <p className="mb-0">اختر صورة شخصية</p>
              <small>PNG, JPG, JPEG حتى 5MB</small>
            </div>
            {formErrors.profile_image && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.profile_image[0]}</div>
            )}
          </div>
        </Col>
        
        {(profileImage || formValues.profile_image) && (
          <Col md={6}>
            <div className="text-center">
              <div className="position-relative d-inline-block">
                <img
                  src={profileImage ? URL.createObjectURL(profileImage) : `${FILE_BASE_URL}/uploads/images/${formValues.profile_image}`}
                  alt="صورة شخصية"
                  className="img-fluid rounded-circle border border-3 border-light shadow-lg"
                  style={{ width: "150px", height: "150px", objectFit: "cover" }}
                />
                <div className="position-absolute top-0 end-0">
                  <Button
                    color="danger"
                    size="sm"
                    onClick={() => {
                      setProfileImage(null);
                      setFormValues(prev => ({...prev, profile_image: ''}));
                      if (profileImageRef.current) profileImageRef.current.value = null;
                    }}
                    className="rounded-circle fw-semibold"
                    style={{ width: '35px', height: '35px' }}
                  >
                    <i className="fas fa-times"></i>
                  </Button>
                </div>
              </div>
              <p className="mt-3 text-success fw-medium">
                <i className="fas fa-check-circle me-1"></i>
                تم رفع الصورة بنجاح
              </p>
            </div>
          </Col>
        )}
      </Row>
    </div>
  </div>
</TabPane>
<TabPane tabId="2">
  {/* ✅ معلومات العنوان والموقع */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-primary fw-bold mb-0">
        <i className="fas fa-map-marker-alt me-2"></i>
        معلومات العنوان والموقع
      </h5>
    </div>
    
    {/* الصف الأول - الدولة والمحافظة والمدينة في صف واحد */}
    <Row className="g-4 mb-4">
      {/* الدولة */}
      <Col md={4}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            الدولة <span className="text-danger">*</span>
          </Label>
          <Input
            type="select"
            name="country"
            value={formValues.country}
            onChange={handleChange}
            className={`form-control-lg border-2 ${formErrors.country ? 'is-invalid border-danger' : 'border-primary'}`}
          >
            <option value="فلسطين">فلسطين</option>
            <option value="الأردن">الأردن</option>
            <option value="لبنان">لبنان</option>
            <option value="سوريا">سوريا</option>
            <option value="مصر">مصر</option>
            <option value="السعودية">السعودية</option>
            <option value="الإمارات">الإمارات</option>
            <option value="قطر">قطر</option>
            <option value="الكويت">الكويت</option>
            <option value="العراق">العراق</option>
            <option value="المغرب">المغرب</option>
            <option value="الجزائر">الجزائر</option>
            <option value="تونس">تونس</option>
            <option value="ليبيا">ليبيا</option>
            <option value="السودان">السودان</option>
            <option value="اليمن">اليمن</option>
            <option value="عمان">عمان</option>
            <option value="البحرين">البحرين</option>
            <option value="أخرى">أخرى</option>
          </Input>
          {formErrors.country && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.country[0]}</div>
          )}
        </div>
      </Col>

      {/* المحافظة - يظهر فقط إذا كانت الدولة فلسطين */}
      {formValues.country === 'فلسطين' && (
        <Col md={4}>
          <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
            <Label className="form-label fw-bold mb-3 text-dark d-block">
              المحافظة <span className="text-danger">*</span>
            </Label>
            <Input
              type="select"
              name="country_province"
              value={formValues.country_province}
              onChange={handleChange}
              className={`form-control-lg border-2 ${formErrors.country_province ? 'is-invalid border-danger' : 'border-primary'}`}
            >
              <option value="">-- اختر المحافظة --</option>
              {[
                "اريحا", "الخليل", "القدس", "بيت لحم", "جنين",
                "رام الله", "سلفيت", "طوباس", "طولكرم", "غزة", "قلقيلية", "نابلس"
              ].map((province) => (
                <option key={province} value={province}>{province}</option>
              ))}
            </Input>
            {formErrors.country_province && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.country_province[0]}</div>
            )}
          </div>
        </Col>
      )}

      {/* المدينة / القرية / المخيم */}
      <Col md={formValues.country === 'فلسطين' ? 4 : 8}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            {formValues.country === 'فلسطين' ? 'المدينة / القرية / المخيم' : 'المدينة / المنطقة'} <span className="text-danger">*</span>
          </Label>
          <Input
            name="city_or_area"
            value={formValues.city_or_area}
            onChange={handleChange}
            className={`form-control-lg border-2 ${formErrors.city_or_area ? 'is-invalid border-danger' : 'border-primary'}`}
            placeholder={formValues.country === 'فلسطين' ? 'أدخل اسم المدينة أو القرية أو المخيم' : 'أدخل اسم المدينة أو المنطقة'}
          />
          {formErrors.city_or_area && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.city_or_area[0]}</div>
          )}
        </div>
      </Col>
    </Row>

    {/* الصف الثاني - تفاصيل العنوان */}
    <div className="mb-4">
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        <Label className="form-label fw-bold mb-3 text-dark d-block">
          <i className="fas fa-home me-2 text-success"></i>
          تفاصيل إضافية للعنوان
        </Label>
        <Input
          type="textarea"
          rows="3"
          name="address_details"
          value={formValues.address_details}
          onChange={handleChange}
          className={`form-control-lg border-2 ${formErrors.address_details ? 'is-invalid border-danger' : 'border-success'}`}
          placeholder="أدخل تفاصيل العنوان مثل: رقم البناية، اسم الشارع، معالم قريبة..."
        />
        {formErrors.address_details && (
          <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.address_details[0]}</div>
        )}
      </div>
    </div>

    {/* الموقع الجغرافي */}
    <div className="mb-4">
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        <Label className="form-label fw-bold mb-3 text-dark d-block">
          <i className="fas fa-globe me-2 text-info"></i>
          الموقع الجغرافي على الخريطة
        </Label>
        
        <Row className="g-3 mb-3">
          <Col md={8}>
            <Input
              name="map_address"
              value={formValues.map_address}
              readOnly
              className={`form-control-lg border-2 ${formErrors.map_address ? 'is-invalid border-danger' : 'border-info'} bg-light`}
              placeholder="سيتم تحديد الموقع تلقائياً عند النقر على الخريطة"
            />
            {formErrors.map_address && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.map_address[0]}</div>
            )}
          </Col>
          <Col md={4}>
            <Button 
              color="info" 
              className="w-100 fw-bold"
              size="lg"
              onClick={() => {
                // يمكن إضافة وظيفة لإعادة تعيين الموقع
                setFormValues(prev => ({...prev, map_address: ''}));
              }}
            >
              <i className="fas fa-map-marked-alt me-1"></i>
              إعادة تحديد الموقع
            </Button>
          </Col>
        </Row>

        {/* الخريطة */}
        <div className="position-relative">
          <div 
            id="map" 
            className="border border-2 border-info rounded-3 shadow-sm"
            style={{ height: "400px", width: "100%" }}
          ></div>
          
          {/* معلومات مساعدة */}
          <div className="mt-3 p-3 bg-light rounded border">
            <div className="d-flex align-items-center text-muted">
              <i className="fas fa-info-circle me-2 text-info"></i>
              <small className="fw-medium">
                انقر على الخريطة لتحديد موقعك بدقة. يمكنك سحب العلامة لتعديل الموقع.
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</TabPane>
       <TabPane tabId="3">
  {/* ✅ معلومات التعليم والعمل */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-success fw-bold mb-0">
        <i className="fas fa-graduation-cap me-2"></i>
        معلومات التعليم والعمل
      </h5>
    </div>
    
    {/* الصف الأول - التخصص والجامعة */}
    <Row className="g-4 mb-4"> 
      {/* التخصص */}
      <Col md={6}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            <i className="fas fa-book me-2 text-success"></i>
            التخصص
          </Label>
          <Input
            name="specialization"
            value={formValues.specialization}
            onChange={handleChange}
            className={`form-control-lg border-2 ${formErrors.specialization ? 'is-invalid border-danger' : 'border-success'}`}
            placeholder="أدخل التخصص الدراسي"
          />
          {formErrors.specialization && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.specialization[0]}</div>
          )}
        </div>
      </Col>

      {/* اسم الجامعة */}
      <Col md={6}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            <i className="fas fa-university me-2 text-success"></i>
            اسم الجامعة
          </Label>
          <Input
            name="university_name"
            value={formValues.university_name}
            onChange={handleChange}
            className={`form-control-lg border-2 ${formErrors.university_name ? 'is-invalid border-danger' : 'border-success'}`}
            placeholder="أدخل اسم الجامعة"
          />
          {formErrors.university_name && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.university_name[0]}</div>
          )}
        </div>
      </Col>
    </Row>

    {/* الصف الثاني - معلومات العمل */}
    <div className="mb-4">
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        <Label className="form-label fw-bold mb-3 text-dark d-block">
          <i className="fas fa-briefcase me-2 text-primary"></i>
          مكان العمل الأخير
        </Label>
        <Input
          name="last_work_place"
          value={formValues.last_work_place}
          onChange={handleChange}
          className={`form-control-lg border-2 ${formErrors.last_work_place ? 'is-invalid border-danger' : 'border-primary'}`}
          placeholder="أدخل اسم الشركة أو المؤسسة"
        />
        {formErrors.last_work_place && (
          <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.last_work_place[0]}</div>
        )}
      </div>
    </div>

    {/* قطاع العمل */}
    <div className="mb-4">
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        <Label className="form-label fw-bold mb-3 text-dark d-block">
          <i className="fas fa-industry me-2 text-warning"></i>
          قطاع العمل
        </Label>
        <p className="text-muted mb-3">اختر قطاع العمل المناسب (يمكن اختيار أكثر من خيار)</p>
        
        <div className="d-flex flex-wrap gap-3">
          {[
            "حكومي مدني", "حكومي عسكري", "قطاع خاص", "مؤسسة غير حكومية",
            "جمعية غير ربحية", "عامل بالخارج", "عامل بالداخل", "بلا عمل"
          ].map(item => {
            const isSelected = formValues.work_sector?.includes(item);
            return (
              <button
                key={item}
                type="button"
                onClick={() => {
                  const exists = formValues.work_sector?.includes(item);
                  setFormValues(prev => ({
                    ...prev,
                    work_sector: exists
                      ? prev.work_sector.filter(v => v !== item)
                      : [...(prev.work_sector || []), item]
                  }));
                }}
                className={`btn ${isSelected 
                  ? 'btn-warning text-dark fw-bold' 
                  : 'btn-outline-dark text-dark bg-light border-2'
                } fw-medium px-3 py-2 rounded-pill`}
                style={{ 
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  transform: isSelected ? 'scale(1.05)' : 'scale(1)',
                  fontSize: '0.9rem'
                }}
              >
                {isSelected && <i className="fas fa-check me-1"></i>}
                {item}
              </button>
            );
          })}
        </div>
        
        {formValues.work_sector?.length > 0 && (
          <div className="mt-3 p-3 bg-light rounded">
            <small className="text-warning fw-bold">
              <i className="fas fa-info-circle me-1"></i>
              تم اختيار {formValues.work_sector.length} قطاع: 
              <span className="text-dark ms-1">
                {formValues.work_sector.join(' - ')}
              </span>
            </small>
          </div>
        )}
        
        {formErrors.work_sector && (
          <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.work_sector[0]}</div>
        )}
      </div>
    </div>

    {/* الروابط المؤسسية */}
    <Row className="g-4">
      {/* الربط مع مؤسسة */}
      <Col md={6}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            <i className="fas fa-building me-2 text-info"></i>
            الربط مع مؤسسات
          </Label>
          
          {/* اختيار من المؤسسات الموجودة */}
          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">
              <i className="fas fa-search me-1 text-info"></i>
              ابحث عن مؤسسة:
            </label>
            <Input
              type="text"
              placeholder="ابحث عن مؤسسة (اكتب اسم أو جزء منه)..."
              className="form-control border-2 border-info mb-2"
              value={institutionSearchTerm}
              onChange={(e) => setInstitutionSearchTerm(e.target.value)}
            />
            <small className="text-muted">اكتب للبحث السريع في أسماء المؤسسات</small>
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">أو اختر من القائمة:</label>
            <Input
              type="select"
              onChange={(e) => {
                if (e.target.value) {
                  handleSelectInstitution(e.target.value);
                  e.target.value = '';
                }
              }}
              className="form-control border-2 border-info"
              size="5"
            >
              <option value="">-- اختر مؤسسة --</option>
              {Array.isArray(filteredInstitutions) && filteredInstitutions
                .filter(inst => !selectedInstitutions.find(sel => sel.id == inst.id))
                .map(inst => (
                  <option key={inst.id} value={inst.id}>{inst.title}</option>
                ))}
            </Input>
            {institutionSearchTerm && filteredInstitutions.length === 0 && (
              <small className="text-warning d-block mt-2">
                <i className="fas fa-exclamation-triangle me-1"></i>
                لا توجد نتائج للبحث "{institutionSearchTerm}"
              </small>
            )}
            {institutionSearchTerm && filteredInstitutions.length > 0 && (
              <small className="text-success d-block mt-2">
                <i className="fas fa-check-circle me-1"></i>
                تم العثور على {filteredInstitutions.length} مؤسسة
              </small>
            )}
          </div>

          {/* إضافة مؤسسة جديدة */}
          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">
              <i className="fas fa-plus-circle me-1 text-success"></i>
              إضافة مؤسسة جديدة:
            </label>
            <InputGroup>
              <Input
                type="text"
                placeholder="اسم المؤسسة الجديدة"
                value={newInstitutionName}
                onChange={(e) => setNewInstitutionName(e.target.value)}
                className="form-control border-2 border-success"
                onKeyPress={(e) => e.key === 'Enter' && handleAddNewInstitution()}
              />
              <Button
                color="success"
                onClick={handleAddNewInstitution}
                disabled={!newInstitutionName.trim()}
              >
                <i className="fas fa-plus"></i>
              </Button>
            </InputGroup>
          </div>

          {/* المؤسسات المختارة */}
          {selectedInstitutions.length > 0 && (
            <div>
              <label className="form-label fw-semibold text-dark mb-2">المؤسسات المختارة:</label>
              <div className="d-flex flex-wrap gap-2">
                {selectedInstitutions.map(inst => (
                  <Badge
                    key={inst.id}
                    color={inst.isNew ? "success" : "info"}
                    className="d-flex align-items-center gap-2 p-2 fs-6"
                  >
                    <i className={`fas ${inst.isNew ? 'fa-plus' : 'fa-building'} me-1`}></i>
                    {inst.title}
                    <Button
                      color="transparent"
                      size="sm"
                      className="p-0 text-white border-0"
                      onClick={() => handleRemoveInstitution(inst.id)}
                      style={{ fontSize: '12px' }}
                    >
                      <i className="fas fa-times"></i>
                    </Button>
                  </Badge>
                ))}
              </div>
              {selectedInstitutions.some(inst => inst.isNew) && (
                <small className="text-success d-block mt-2">
                  <i className="fas fa-info-circle me-1"></i>
                  المؤسسات الجديدة سيتم إنشاؤها تلقائياً عند الحفظ
                </small>
              )}
            </div>
          )}

          {formErrors.linked_institution && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.linked_institution[0]}</div>
          )}
        </div>
      </Col>

      {/* الربط مع صحفيين */}
      <Col md={6}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            <i className="fas fa-users me-2 text-secondary"></i>
            الربط مع صحفيين
          </Label>
          
          {/* اختيار من الصحفيين الموجودين */}
          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">
              <i className="fas fa-search me-1 text-secondary"></i>
              ابحث عن صحفي:
            </label>
            <Input
              type="text"
              placeholder="ابحث عن صحفي (اكتب اسم أو جزء منه)..."
              className="form-control border-2 border-secondary mb-2"
              value={journalistSearchTerm}
              onChange={(e) => setJournalistSearchTerm(e.target.value)}
            />
            <small className="text-muted">اكتب للبحث السريع في أسماء الصحفيين</small>
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">أو اختر من القائمة:</label>
            <Input
              type="select"
              onChange={(e) => {
                if (e.target.value) {
                  handleSelectJournalist(e.target.value);
                  e.target.value = '';
                }
              }}
              className="form-control border-2 border-secondary"
              size="5"
            >
              <option value="">-- اختر صحفي --</option>
              {filteredJournalistsList?.filter(jour => !selectedJournalists.find(sel => sel.id == jour.id))
                .map(jour => (
                  <option key={jour.id} value={jour.id}>{jour.full_name}</option>
                ))}
            </Input>
            {journalistSearchTerm && filteredJournalistsList.length === 0 && (
              <small className="text-warning d-block mt-2">
                <i className="fas fa-exclamation-triangle me-1"></i>
                لا توجد نتائج للبحث "{journalistSearchTerm}"
              </small>
            )}
            {journalistSearchTerm && filteredJournalistsList.length > 0 && (
              <small className="text-success d-block mt-2">
                <i className="fas fa-check-circle me-1"></i>
                تم العثور على {filteredJournalistsList.length} صحفي
              </small>
            )}
          </div>

          {/* إضافة صحفي جديد */}
          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">
              <i className="fas fa-plus-circle me-1 text-warning"></i>
              إضافة صحفي جديد:
            </label>
            <InputGroup>
              <Input
                type="text"
                placeholder="اسم الصحفي الجديد"
                value={newJournalistName}
                onChange={(e) => setNewJournalistName(e.target.value)}
                className="form-control border-2 border-warning"
                onKeyPress={(e) => e.key === 'Enter' && handleAddNewJournalist()}
              />
              <Button
                color="warning"
                onClick={handleAddNewJournalist}
                disabled={!newJournalistName.trim()}
              >
                <i className="fas fa-plus"></i>
              </Button>
            </InputGroup>
          </div>

          {/* الصحفيين المختارين */}
          {selectedJournalists.length > 0 && (
            <div>
              <label className="form-label fw-semibold text-dark mb-2">الصحفيين المختارين:</label>
              <div className="d-flex flex-wrap gap-2">
                {selectedJournalists.map(jour => (
                  <Badge
                    key={jour.id}
                    color={jour.isNew ? "warning" : "secondary"}
                    className="d-flex align-items-center gap-2 p-2 fs-6"
                  >
                    <i className={`fas ${jour.isNew ? 'fa-plus' : 'fa-user'} me-1`}></i>
                    {jour.full_name}
                    <Button
                      color="transparent"
                      size="sm"
                      className="p-0 text-white border-0"
                      onClick={() => handleRemoveJournalist(jour.id)}
                      style={{ fontSize: '12px' }}
                    >
                      <i className="fas fa-times"></i>
                    </Button>
                  </Badge>
                ))}
              </div>
              {selectedJournalists.some(jour => jour.isNew) && (
                <small className="text-warning d-block mt-2">
                  <i className="fas fa-info-circle me-1"></i>
                  الصحفيين الجدد سيتم إنشاؤهم تلقائياً عند الحفظ
                </small>
              )}
            </div>
          )}

          {formErrors.linked_journalists && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.linked_journalists[0]}</div>
          )}
        </div>
      </Col>
    </Row>

    {/* 🔗 الربط مع ناشطين آخرين */}
    <Row className="g-4 mt-1">
      <Col md={12}>
        <div className="p-4 border rounded-3 h-100 shadow-sm bg-white">
          <Label className="form-label fw-bold mb-3 text-dark d-block">
            <i className="fas fa-user-friends me-2 text-warning"></i>
            الربط مع ناشطين آخرين
          </Label>

          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">
              <i className="fas fa-search me-1 text-warning"></i>
              ابحث عن ناشط:
            </label>
            <Input
              type="text"
              placeholder="ابحث عن ناشط (اكتب اسم أو جزء منه)..."
              className="form-control border-2 border-warning mb-2"
              value={activistPeerSearchTerm}
              onChange={(e) => setActivistPeerSearchTerm(e.target.value)}
            />
            <small className="text-muted">اكتب للبحث السريع في أسماء الناشطين</small>
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold text-dark mb-2">أو اختر من القائمة:</label>
            <Input
              type="select"
              onChange={(e) => {
                if (e.target.value) {
                  handleSelectActivistPeer(e.target.value);
                  e.target.value = '';
                }
              }}
              className="form-control border-2 border-warning"
              size="5"
            >
              <option value="">-- اختر ناشط --</option>
              {Array.isArray(filteredActivistPeers) && filteredActivistPeers
                .filter(act => !activistData || act.id != activistData.id)
                .filter(act => !selectedActivistPeers.find(sel => sel.id == act.id))
                .map(act => (
                  <option key={act.id} value={act.id}>{act.full_name}</option>
                ))}
            </Input>
            {activistPeerSearchTerm && filteredActivistPeers.length === 0 && (
              <small className="text-warning d-block mt-2">
                <i className="fas fa-exclamation-triangle me-1"></i>
                لا توجد نتائج للبحث "{activistPeerSearchTerm}"
              </small>
            )}
            {activistPeerSearchTerm && filteredActivistPeers.length > 0 && (
              <small className="text-success d-block mt-2">
                <i className="fas fa-check-circle me-1"></i>
                تم العثور على {filteredActivistPeers.length} ناشط
              </small>
            )}
          </div>

          {selectedActivistPeers.length > 0 && (
            <div>
              <label className="form-label fw-semibold text-dark mb-2">الناشطون المختارون:</label>
              <div className="d-flex flex-wrap gap-2">
                {selectedActivistPeers.map(act => (
                  <Badge
                    key={act.id}
                    color="warning"
                    className="d-flex align-items-center gap-2 p-2 fs-6"
                  >
                    <i className="fas fa-user me-1"></i>
                    {act.full_name}
                    <Button
                      color="transparent"
                      size="sm"
                      className="p-0 text-white border-0"
                      onClick={() => handleRemoveActivistPeer(act.id)}
                      style={{ fontSize: '12px' }}
                    >
                      <i className="fas fa-times"></i>
                    </Button>
                  </Badge>
                ))}
              </div>
            </div>
          )}

          {formErrors.linked_activists && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.linked_activists[0]}</div>
          )}
        </div>
      </Col>
    </Row>
  </div>
</TabPane>

            <TabPane tabId="4">
  {/* ✅ وسائل التواصل */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-primary fw-bold mb-0">
        <i className="fas fa-phone me-2"></i>
        وسائل التواصل والاتصال
      </h5>
    </div>
    
    {/* أرقام الهاتف */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-success">
        <h6 className="text-success fw-bold mb-0">
          <i className="fab fa-whatsapp me-2"></i>
          أرقام الهاتف
        </h6>
      </div>
      <Row className="g-4">
        {/* واتساب */}
        <Col md={6}>
          <div className="p-4 border rounded-3 shadow-sm bg-white">
            <Label className="form-label fw-bold mb-3 text-dark d-block">
              واتساب <span className="text-danger">*</span>
            </Label>
            <InputGroup className="input-group-lg">
              <Input
                type="text"
                name="whatsapp1_number"
                placeholder="رقم الجوال"
                value={formValues.whatsapp1_number || ''}
                onChange={handleChange}
                className={`border-2 ${formErrors.whatsapp1 ? 'is-invalid border-danger' : 'border-success'}`}
              />
              <select
                name="whatsapp1_code"
                value={formValues.whatsapp1_code || '+970'}
                onChange={handleChange}
                className={`form-select border-2 ${formErrors.whatsapp1 ? 'is-invalid border-danger' : 'border-success'}`}
                style={{ maxWidth: '100px' }}
              >
                <option value="+970">+970</option>
                <option value="+972">+972</option>
              </select>
            </InputGroup>
            {formErrors.whatsapp1 && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.whatsapp1[0]}</div>
            )}
          </div>
        </Col>

        {/* تلفون/فاكس */}
        <Col md={6}>
          <div className="p-4 border rounded-3 shadow-sm bg-white">
            <Label className="form-label fw-bold mb-3 text-dark d-block">تلفون/فاكس</Label>
            <Input
              name="phone_fax"
              value={formValues.phone_fax}
              onChange={handleChange}
              placeholder="رقم التلفون أو الفاكس"
              className={`form-control-lg border-2 ${formErrors.phone_fax ? 'is-invalid border-danger' : 'border-success'}`}
            />
            {formErrors.phone_fax && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.phone_fax[0]}</div>
            )}
          </div>
        </Col>
      </Row>
    </div>

    {/* أرقام الجوال */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-info">
        <h6 className="text-info fw-bold mb-0">
          <i className="fas fa-mobile-alt me-2"></i>
          أرقام الجوال
        </h6>
      </div>
      <Row className="g-4">
        {/* جوال 1 */}
        <Col md={6}>
          <div className="p-4 border rounded-3 shadow-sm bg-white">
            <Label className="form-label fw-bold mb-3 text-dark d-block">جوال</Label>
            <Input
              name="mobile1"
              value={formValues.mobile1}
              onChange={handleChange}
              placeholder="أدخل رقم الجوال"
              className={`form-control-lg border-2 ${formErrors.mobile1 ? 'is-invalid border-danger' : 'border-info'}`}
            />
            {formErrors.mobile1 && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.mobile1[0]}</div>
            )}
          </div>
        </Col>

        {/* أوريدو */}
        <Col md={6}>
          <div className="p-4 border rounded-3 shadow-sm bg-white">
            <Label className="form-label fw-bold mb-3 text-dark d-block">رقم أوريدو</Label>
            <Input
              name="oreedo_number"
              value={formValues.oreedo_number}
              onChange={handleChange}
              placeholder="رقم أوريدو"
              className={`form-control-lg border-2 ${formErrors.oreedo_number ? 'is-invalid border-danger' : 'border-info'}`}
            />
            {formErrors.oreedo_number && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.oreedo_number[0]}</div>
            )}
          </div>
        </Col>
      </Row>
    </div>

    {/* البريد الإلكتروني والموقع */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-warning">
        <h6 className="text-warning fw-bold mb-0">
          <i className="fas fa-globe me-2"></i>
          الاتصال الإلكتروني
        </h6>
      </div>
      <Row className="g-4">
        {/* البريد الإلكتروني */}
        <Col md={6}>
          <div className="p-4 border rounded-3 shadow-sm bg-white">
            <Label className="form-label fw-bold mb-3 text-dark d-block">
              <i className="fas fa-envelope me-2 text-warning"></i>
              البريد الإلكتروني
            </Label>
            <Input
              type="email"
              name="email"
              value={formValues.email}
              onChange={handleChange}
              placeholder="example@domain.com"
              className={`form-control-lg border-2 ${formErrors.email ? 'is-invalid border-danger' : 'border-warning'}`}
            />
            {formErrors.email && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.email[0]}</div>
            )}
          </div>
        </Col>

        {/* الموقع الإلكتروني */}
        <Col md={6}>
          <div className="p-4 border rounded-3 shadow-sm bg-white">
            <Label className="form-label fw-bold mb-3 text-dark d-block">
              <i className="fas fa-link me-2 text-warning"></i>
              الموقع الإلكتروني
            </Label>
            <Input
              type="url"
              name="website"
              value={formValues.website}
              onChange={handleChange}
              placeholder="https://www.example.com"
              className={`form-control-lg border-2 ${formErrors.website ? 'is-invalid border-danger' : 'border-warning'}`}
            />
            {formErrors.website && (
              <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.website[0]}</div>
            )}
          </div>
        </Col>
      </Row>
    </div>

    {/* حسابات التواصل الاجتماعي */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-secondary">
        <h6 className="text-secondary fw-bold mb-0">
          <i className="fas fa-share-alt me-2"></i>
          حسابات التواصل الاجتماعي
        </h6>
      </div>
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        {/* إضافة حساب جديد */}
        <div className="mb-4 p-3 border-2 border-dashed border-secondary rounded-3 bg-light">
          <Label className="form-label fw-bold mb-3 text-dark d-block">إضافة رابط حساب التواصل</Label>
          <InputGroup className="input-group-lg">
            <Input
              placeholder="https://facebook.com/username أو https://twitter.com/username"
              value={newSocialAccount}
              onChange={(e) => setNewSocialAccount(e.target.value)}
              className="border-2 border-secondary"
            />
            <Button
              color="secondary"
              onClick={() =>
                handleAddToArray('social_accounts', setNewSocialAccount, newSocialAccount)
              }
              className="fw-bold"
            >
              <i className="fas fa-plus me-1"></i>
              إضافة
            </Button>
          </InputGroup>
        </div>

        {/* عرض الحسابات المضافة */}
        {formValues.social_accounts?.length > 0 ? (
          <div>
            <Label className="form-label fw-bold mb-3 text-dark d-block">الحسابات المضافة:</Label>
            <div className="list-group">
              {formValues.social_accounts?.map((link, i) => (
                <div key={i} className="list-group-item d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <i className="fas fa-link fa-lg me-3 text-secondary"></i>
                    <div>
                      <div className="fw-medium">{link}</div>
                      <small className="text-muted">رابط</small>
                    </div>
                  </div>
                  <Button 
                    color="outline-danger" 
                    size="sm"
                    onClick={() => handleRemoveFromArray('social_accounts', i)}
                    className="fw-medium"
                  >
                    <i className="fas fa-trash me-1"></i>
                    حذف
                  </Button>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            <i className="fas fa-share-alt fa-2x mb-3 opacity-50"></i>
            <p>لم يتم إضافة أي حسابات تواصل اجتماعي بعد</p>
          </div>
        )}
      </div>
    </div>
  </div>
</TabPane>

            <TabPane tabId="5">
  {/* ✅ المرفقات والوسائط */}
  <div className="mb-5">
    <div className="mb-3 pb-2 border-bottom">
      <h5 className="text-info fw-bold mb-0">
        <i className="fas fa-file-upload me-2"></i>
        المرفقات والوسائط
      </h5>
    </div>

    {/* ✅ الأقوال والتصريحات */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-success">
        <h6 className="text-success fw-bold mb-0">
          <i className="fas fa-quote-left me-2"></i>
          الأقوال والتصريحات
        </h6>
      </div>
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        {/* زر إضافة تصريح */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h6 className="text-success fw-bold mb-0">
            <i className="fas fa-quote-left me-2"></i>
            قائمة التصريحات
          </h6>
          <Button 
            color="success" 
            onClick={handleOpenStatementModal}
            className="fw-bold"
            size="lg"
          >
            <i className="fas fa-plus me-2"></i>
            إضافة تصريح
          </Button>
        </div>

        {/* عرض التصريحات */}
        {statements.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-hover table-striped align-middle border-2">
              <thead className="table-success">
                <tr>
                  <th className="fw-bold fs-6 py-3" style={{width: '60px'}}>#</th>
                  <th className="fw-bold fs-6 py-3" style={{width: '200px'}}>العنوان</th>
                  <th className="fw-bold fs-6 py-3">التصريح</th>
                  <th className="fw-bold fs-6 py-3 text-center" style={{width: '150px'}}>العمليات</th>
                </tr>
              </thead>
              <tbody>
                {statements.map((statement, index) => (
                  <tr key={statement.id}>
                    <td className="fw-medium text-muted py-3">{index + 1}</td>
                    <td className="fw-semibold text-dark py-3">{statement.title}</td>
                    <td className="py-3" style={{maxWidth: '350px'}}>
                      <div className="text-truncate" title={statement.content}>
                        {statement.content.length > 100 
                          ? statement.content.substring(0, 100) + '...'
                          : statement.content
                        }
                      </div>
                    </td>
                    <td className="text-center py-3">
                      <div className="d-flex justify-content-center gap-2">
                        <Button
                          color="outline-warning"
                          size="sm"
                          onClick={() => handleEditStatement(statement)}
                          className="fw-medium"
                        >
                          <i className="fas fa-edit me-1"></i>
                          تحرير
                        </Button>
                        <Button
                          color="outline-danger"
                          size="sm"
                          onClick={() => handleDeleteStatement(statement.id)}
                          className="fw-medium"
                        >
                          <i className="fas fa-trash me-1"></i>
                          حذف
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center py-5 text-muted">
            <i className="fas fa-quote-left fa-3x mb-3 opacity-50"></i>
            <p className="fs-5">لا توجد تصريحات مضافة</p>
          </div>
        )}
      </div>
    </div>

    {/* ✅ روابط يوتيوب */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-danger">
        <h6 className="text-danger fw-bold mb-0">
          <i className="fab fa-youtube me-2"></i>
          روابط يوتيوب
        </h6>
      </div>
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        {/* إضافة رابط يوتيوب */}
        <div className="p-4 border-2 border-dashed border-danger rounded-3 mb-4 bg-light">
          <Label className="form-label fw-bold mb-3 text-dark d-block">إضافة رابط يوتيوب</Label>
          <InputGroup className="input-group-lg">
            <Input
              placeholder="https://youtube.com/watch?v=..."
              value={newYoutubeLink}
              onChange={(e) => setNewYoutubeLink(e.target.value)}
              className={`border-2 ${formErrors.videos ? 'is-invalid border-danger' : 'border-danger'}`}
            />
            <Button
              color="danger"
              onClick={() => handleAddToArray('videos', setNewYoutubeLink, newYoutubeLink)}
              className="fw-bold"
            >
              <i className="fab fa-youtube me-1"></i>
              إضافة
            </Button>
          </InputGroup>
          {formErrors.videos && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.videos[0]}</div>
          )}
        </div>

        {/* عرض روابط اليوتيوب */}
        {formValues.videos?.length > 0 ? (
          <div>
            <Label className="form-label fw-bold mb-3 text-dark d-block">الفيديوهات المضافة:</Label>
            <div className="list-group">
              {formValues.videos.map((link, i) => (
                <div key={i} className="list-group-item d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <i className="fab fa-youtube fa-lg me-3 text-danger"></i>
                    <div>
                      <div className="fw-medium text-truncate" style={{maxWidth: '400px'}}>{link}</div>
                      <small className="text-muted">فيديو يوتيوب</small>
                    </div>
                  </div>
                  <Button 
                    color="outline-danger" 
                    size="sm"
                    onClick={() => handleRemoveFromArray('videos', i)}
                    className="fw-medium"
                  >
                    <i className="fas fa-trash me-1"></i>
                    حذف
                  </Button>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            <i className="fab fa-youtube fa-2x mb-3 opacity-50"></i>
            <p>لم يتم إضافة أي فيديوهات يوتيوب بعد</p>
          </div>
        )}
      </div>
    </div>

    {/* 🆕 ملفات الفيديو */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-purple" style={{borderColor: '#6f42c1'}}>
        <h6 className="fw-bold mb-0" style={{color: '#6f42c1'}}>
          <i className="fas fa-video me-2"></i>
          ملفات الفيديو
        </h6>
      </div>
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        {/* رفع الفيديو */}
        <div className="p-4 border-2 border-dashed rounded-3 mb-4 bg-light" style={{borderColor: '#6f42c1'}}>
          <Label className="form-label fw-bold mb-3 text-dark d-block">رفع ملفات الفيديو</Label>
          <Input
            type="file"
            multiple
            accept="video/mp4,video/webm,video/ogg,video/avi,video/mov,video/wmv,video/mkv,video/flv,video/3gp,video/m4v,.mp4,.webm,.ogg,.avi,.mov,.wmv,.mkv,.flv,.3gp,.m4v"
            onChange={handleVideoUpload}
            className={`form-control-lg border-2 ${formErrors.video_files ? 'is-invalid border-danger' : ''}`}
            style={{borderColor: '#6f42c1'}}
            innerRef={videoInputRef}
          />
          <div className="mt-2 text-muted text-center">
            <i className="fas fa-cloud-upload-alt fa-2x mb-2"></i>
            <p className="mb-0">اختر ملفات فيديو متعددة</p>
            <small>MP4, WebM, OGG, AVI, MOV, WMV, MKV, FLV, 3GP, M4V - حتى 1GB لكل ملف</small>
          </div>
          {formErrors.video_files && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.video_files[0]}</div>
          )}
        </div>

        {/* عرض ملفات الفيديو */}
        {videoFiles.length > 0 ? (
          <div>
            <Label className="form-label fw-bold mb-3 text-dark d-block">ملفات الفيديو ({videoFiles.length}):</Label>
            <div className="list-group">
              {videoFiles.map((file, index) => {
                const isUploaded = typeof file === 'string';
                const tempId = !isUploaded ? file.tempId : null;
                const uploadState = tempId ? videoUploading[tempId] : null;
                const fileName = isUploaded ? file : file.name;
                const fileSize = isUploaded ? '' : (file.size / (1024 * 1024)).toFixed(1) + ' MB';
                const isUploading = uploadState?.status === 'uploading';
                const hasError = uploadState?.status === 'error';
                
                return (
                  <div key={tempId || index} className="list-group-item">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center flex-grow-1">
                        {isUploading ? (
                          <div className="spinner-border spinner-border-sm me-3" style={{color: '#6f42c1'}} role="status">
                            <span className="visually-hidden">جاري الرفع...</span>
                          </div>
                        ) : isUploaded ? (
                          <i className="fas fa-check-circle fa-lg me-3 text-success"></i>
                        ) : hasError ? (
                          <i className="fas fa-exclamation-circle fa-lg me-3 text-danger"></i>
                        ) : (
                          <i className="fas fa-video fa-lg me-3" style={{color: '#6f42c1'}}></i>
                        )}
                        <div className="flex-grow-1">
                          <div className="fw-medium text-truncate" style={{maxWidth: '400px'}}>{fileName}</div>
                          <small className="text-muted">
                            {isUploading ? (
                              <span className="text-primary">جاري الرفع... {uploadState?.progress || 0}%</span>
                            ) : isUploaded ? (
                              <span className="text-success">✓ تم الرفع بنجاح</span>
                            ) : hasError ? (
                              <span className="text-danger">{uploadState?.message || 'فشل الرفع'}</span>
                            ) : (
                              `فيديو • ${fileSize}`
                            )}
                          </small>
                        </div>
                      </div>
                      {isUploaded && (
                        <Button
                          color="outline-danger"
                          size="sm"
                          onClick={() => {
                            const updated = [...videoFiles];
                            updated.splice(index, 1);
                            setVideoFiles(updated);
                          }}
                          className="fw-medium"
                        >
                          <i className="fas fa-trash me-1"></i>
                          حذف
                        </Button>
                      )}
                    </div>
                    {/* شريط التقدم */}
                    {isUploading && (
                      <div className="progress mt-2" style={{height: '6px'}}>
                        <div 
                          className="progress-bar" 
                          role="progressbar" 
                          style={{width: `${uploadState?.progress || 0}%`, backgroundColor: '#6f42c1'}}
                          aria-valuenow={uploadState?.progress || 0} 
                          aria-valuemin="0" 
                          aria-valuemax="100"
                        ></div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            <i className="fas fa-video fa-2x mb-3 opacity-50"></i>
            <p>لم يتم رفع أي ملفات فيديو بعد</p>
          </div>
        )}
      </div>
    </div>

    {/* ✅ الصور */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-warning">
        <h6 className="text-warning fw-bold mb-0">
          <i className="fas fa-images me-2"></i>
          الصور
        </h6>
      </div>
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        {/* رفع الصور */}
        <div className="p-4 border-2 border-dashed border-warning rounded-3 mb-4 bg-light">
          <Label className="form-label fw-bold mb-3 text-dark d-block">رفع الصور</Label>
          <Input
            type="file"
            multiple
            accept="image/*"
            onChange={handleImageUpload}
            className={`form-control-lg border-2 ${formErrors.images ? 'is-invalid border-danger' : 'border-warning'}`}
            innerRef={imageInputRef}
          />
          <div className="mt-2 text-muted text-center">
            <i className="fas fa-cloud-upload-alt fa-2x mb-2"></i>
            <p className="mb-0">اختر صور متعددة</p>
            <small>PNG, JPG, JPEG حتى 5MB لكل صورة</small>
          </div>
          {formErrors.images && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.images[0]}</div>
          )}
        </div>

        {/* عرض الصور */}
        {images.length > 0 ? (
          <div>
            <Label className="form-label fw-bold mb-3 text-dark d-block">الصور المرفوعة ({images.length}):</Label>
            <Row className="g-3">
              {images.map((file, index) => {
                const isExisting = typeof file === 'string';
             const imageUrl = isExisting
                 ? `${FILE_BASE_URL}/uploads/images/${file}`
                 : URL.createObjectURL(file);

                return (
                  <Col key={index} md={2} sm={3} xs={4}>
                    <div className="position-relative">
                      <img
                        src={imageUrl}
                        alt={`preview-${index}`}
                        className="img-fluid rounded shadow-sm border border-2 border-warning"
                        style={{ height: "120px", width: "100%", objectFit: "cover" }}
                      />
                      <Button
                        color="danger"
                        onClick={() => {
                          const updated = [...images];
                          updated.splice(index, 1);
                          setImages(updated);
                          if (!isExisting && imageInputRef.current) imageInputRef.current.value = null;
                        }}
                        className="position-absolute top-0 end-0 rounded-circle"
                        style={{
                          width: "30px",
                          height: "30px",
                          padding: "0",
                          fontSize: "12px",
                          transform: "translate(50%, -50%)"
                        }}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            <i className="fas fa-images fa-2x mb-3 opacity-50"></i>
            <p>لم يتم رفع أي صور بعد</p>
          </div>
        )}
      </div>
    </div>

    {/* ✅ مرفقات أخرى */}
    <div className="mb-5">
      <div className="mb-3 pb-2 border-bottom border-secondary">
        <h6 className="text-secondary fw-bold mb-0">
          <i className="fas fa-paperclip me-2"></i>
          مرفقات أخرى
        </h6>
      </div>
      <div className="p-4 border rounded-3 shadow-sm bg-white">
        {/* رفع المرفقات */}
        <div className="p-4 border-2 border-dashed border-secondary rounded-3 mb-4 bg-light">
          <Label className="form-label fw-bold mb-3 text-dark d-block">رفع الملفات</Label>
          <Input
            type="file"
            multiple
            accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.ppt,.pptx"
            onChange={(e) => {
              const files = Array.from(e.target.files);
              setFormValues(prev => ({
                ...prev,
                attachments: [...prev.attachments, ...files]
              }));
              if (attachmentInputRef.current) attachmentInputRef.current.value = null;
            }}
            className={`form-control-lg border-2 ${formErrors.attachments ? 'is-invalid border-danger' : 'border-secondary'}`}
            innerRef={attachmentInputRef}
          />
          <div className="mt-2 text-muted text-center">
            <i className="fas fa-file-upload fa-2x mb-2"></i>
            <p className="mb-0">اختر ملفات متعددة</p>
            <small>PDF, Word, Excel, PowerPoint, TXT حتى 10MB لكل ملف</small>
          </div>
          {formErrors.attachments && (
            <div className="invalid-feedback d-block fw-medium mt-2">{formErrors.attachments[0]}</div>
          )}
        </div>

        {/* عرض المرفقات */}
        {formValues.attachments?.length > 0 ? (
          <div>
            <Label className="form-label fw-bold mb-3 text-dark d-block">الملفات المرفقة ({formValues.attachments.length}):</Label>
            <div className="list-group">
              {formValues.attachments.map((file, index) => {
                const fileName = typeof file === 'string' ? file : file.name;
                const [icon, iconColor, label] = renderFileMeta(fileName);
                return (
                  <div key={index} className="list-group-item d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <i className={`${icon} fa-lg me-3 ${iconColor}`}></i>
                      <div>
                        <div className="fw-medium text-truncate" style={{ maxWidth: 400 }}>{fileName}</div>
                        <small className="text-muted">{label}</small>
                      </div>
                    </div>
                    <Button
                      color="outline-danger"
                      size="sm"
                      onClick={() =>
                        setFormValues(prev => ({
                          ...prev,
                          attachments: prev.attachments.filter((_, i) => i !== index)
                        }))
                      }
                      className="fw-medium"
                    >
                      <i className="fas fa-trash me-1"></i> حذف
                    </Button>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            <i className="fas fa-paperclip fa-2x mb-3 opacity-50"></i>
            <p>لم يتم رفع أي ملفات بعد</p>
          </div>
        )}
      </div>
    </div>
  </div>
</TabPane>
          </TabContent>
          
          <div className="text-end mt-4">
            <Button color="primary" type="submit" disabled={isSubmitting || !areAllVideosUploaded()}>
              {!areAllVideosUploaded() ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                  جاري رفع الفيديوهات...
                </>
              ) : isSubmitting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                  جاري الحفظ...
                </>
              ) : (
                mode === 'edit' ? 'تحديث الناشط' : 'إضافة الناشط'
              )}
            </Button>
          </div>
        </Form>
      </CardBody>
    </Card>

    {/* 🆕 Modal إضافة/تحرير التصريحات */}
    <Modal 
      isOpen={showStatementModal} 
      toggle={handleCancelStatementModal} 
      size="lg"
      style={{ zIndex: 10000 }}
      backdropClassName="modal-backdrop-tinymce"
    >
      <ModalHeader toggle={handleCancelStatementModal}>
        <i className="fas fa-quote-left me-2 text-success"></i>
        {editingStatement ? 'تحرير التصريح' : 'إضافة تصريح جديد'}
      </ModalHeader>
      <ModalBody>
        <Form>
          {/* عنوان التصريح */}
          <div className="mb-4">
            <Label className="form-label fw-bold mb-3 text-dark d-block">
              عنوان التصريح <span className="text-danger">*</span>
            </Label>
            <Input
              placeholder="أدخل عنوان التصريح"
              value={newStatement.title}
              onChange={(e) => setNewStatement({...newStatement, title: e.target.value})}
              className="form-control-lg border-2 border-success"
            />
          </div>

          {/* نص التصريح - محرر غني */}
          <div className="mb-4">
            <Label className="form-label fw-bold mb-3 text-dark d-block">
              نص التصريح <span className="text-danger">*</span>
            </Label>
            <div className="border border-2 border-success rounded">
              <Editor
                value={newStatement.content}
                onEditorChange={(content) => setNewStatement({...newStatement, content})}
                init={{
                  height: 400,
                  menubar: false,
                  plugins: [
                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                    'insertdatetime', 'media', 'table', 'wordcount', 'paste'
                  ],
                  toolbar: 'undo redo | styles | fontfamily fontsize | forecolor backcolor | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | link image media | removeformat | code fullscreen',
                  
                  // ✅ نفس إعدادات محرر السيرة الذاتية
                  style_formats_merge: true,
                  formats: {
                    alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'left' },
                    aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'center' },
                    alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'right' },
                    alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'full' }
                  },
                  
                  // ✅ خطوط متنوعة
                  font_formats: 
                    'Arial=arial,helvetica,sans-serif;' +
                    'Times New Roman=times new roman,times,serif;' +
                    'Courier New=courier new,courier,monospace;' +
                    'Tahoma=tahoma,arial,helvetica,sans-serif;' +
                    'Verdana=verdana,arial,helvetica,sans-serif;' +
                    'Georgia=georgia,serif;' +
                    'Comic Sans MS=comic sans ms,cursive',
                  
                  // ✅ أحجام خطوط متنوعة
                  fontsize_formats: '8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 28pt 36pt 48pt 72pt',
                  
                  toolbar_mode: 'wrap',
                  branding: false,
                  resize: true,
                  statusbar: true,
                  
                  // ✅ CSS للمحاذاة
                  content_style: `
                    body { 
                      font-family: Tahoma, Arial, sans-serif; 
                      font-size: 16px; 
                      direction: rtl; 
                    }
                    
                    .left { text-align: left !important; }
                    .center { text-align: center !important; }
                    .right { text-align: right !important; }
                    .full { text-align: justify !important; }
                    
                    p, h1, h2, h3, h4, h5, h6, div, ul, ol, li, table, td, th {
                      direction: rtl;
                    }
                  `,
                  
                  // ✅ المحرر بالإنجليزية لإظهار جميع الخيارات
                  language: 'en', // واجهة إنجليزية
                  directionality: 'rtl', // الاتجاه يبقى من اليمين لليسار للعربية
                  
                  // ✅ دعم نسخ ولصق مع تنسيقات وصور
                  paste_data_images: true,
                  paste_as_text: false,
                  paste_retain_style_properties: 'all',
                  automatic_uploads: true,
                  file_picker_types: 'image',
                  images_upload_handler: function (blobInfo, success, failure) {
                    const reader = new FileReader();
                    reader.onload = function() {
                      success(reader.result);
                    };
                    reader.readAsDataURL(blobInfo.blob());
                  },
                  
                  setup: function (editor) {
                    editor.on('init', function () {
                      console.log('TinyMCE Statements Editor loaded successfully!');
                      
                      // تأكد من ظهور أدوات الخط والحجم
                      setTimeout(() => {
                        const fontSelect = editor.getContainer().querySelector('.tox-tbtn[aria-label*="Font"]');
                        const sizeSelect = editor.getContainer().querySelector('.tox-tbtn[aria-label*="Size"]');
                        
                        if (!fontSelect) console.warn('Font selector issue');
                        if (!sizeSelect) console.warn('Font size selector issue');
                      }, 1000);
                    });
                  }
                }}
              />
            </div>
          </div>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button 
          color="success" 
          onClick={handleSaveStatement}
          disabled={!newStatement.title.trim() || !newStatement.content.trim()}
          className="fw-bold px-4"
        >
          <i className="fas fa-save me-2"></i>
          {editingStatement ? 'حفظ التعديلات' : 'إضافة التصريح'}
        </Button>
        <Button 
          color="outline-secondary" 
          onClick={handleCancelStatementModal}
          className="fw-medium px-4"
        >
          <i className="fas fa-times me-2"></i>
          إلغاء
        </Button>
      </ModalFooter>
    </Modal>

    {/* 🆕 بوب أب تأكيد الحفظ عند وجود أسماء مكررة */}
    <DuplicateSaveConfirm
      isOpen={showDuplicateConfirm}
      matches={duplicateWarning}
      onConfirm={() => { setShowDuplicateConfirm(false); doActualSubmit(); }}
      onCancel={() => { setShowDuplicateConfirm(false); setIsSubmitting(false); }}
    />
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(CreateActivist);